import React from 'react';
import StaffBottomNav from '../../components/StaffBottomNav';
import StaffScanSurface from '../../components/staff/StaffScanSurface';

export default function StaffScanPage() {
  return (
    <StaffScanSurface
      basePath="/staff-app"
      bottomNav={<StaffBottomNav />}
      pageTestId="staff-scan-page"
      testIdPrefix="staff"
      roleLabel="Venue staff"
    />
  );
}